import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { eps } from './url.service'
import {
  PayoutAgreement,
  IncomingPayoutAgreement
} from '../store/payout-agreement/payout-agreement.state'

@Injectable({
  providedIn: 'root'
})
export class PayoutAgreementService {
  http = inject(HttpClient)
  api = eps.hrm.createPayoutApi

  addPayoutAgreement(payoutAgreement: PayoutAgreement) {
    return this.http.post<IncomingPayoutAgreement>(this.api, payoutAgreement)
  }

  //Load All Payout Agreements
  loadAllPayoutAgreements(employeeId: string) {
    return this.http.get<IncomingPayoutAgreement[]>(this.api + '/all', { params: { employeeId } })
  }

  getPayoutAgreement(employeeId: string) {
    return this.http.get<IncomingPayoutAgreement | null>(this.api, {
      params: { employeeId }
    })
  }

  saveRevisedPayout(payoutAgreement: PayoutAgreement) {
    const payload: PayoutAgreement = {
      payoutFrequency: payoutAgreement.payoutFrequency,
      basis: payoutAgreement.basis,
      currency: payoutAgreement.currency,
      belongsTo: payoutAgreement.belongsTo,
      employeeId: payoutAgreement.employeeId,
      statutoryCompliances: payoutAgreement.statutoryCompliances,
      ctc: Number(payoutAgreement.ctc),
      payoutData: payoutAgreement.payoutData,
      effectiveFrom: payoutAgreement.effectiveFrom,
      payoutFrom: payoutAgreement.payoutFrom
    }
    return this.http.post<{ payout: IncomingPayoutAgreement }>(this.api + '/revise', payload)
  }

  editPayout(payoutAgreement: PayoutAgreement) {
    const payload: PayoutAgreement = {
      ...payoutAgreement,
      ctc: Number(payoutAgreement.ctc)
    }
    return this.http.put<IncomingPayoutAgreement>(this.api, payload)
  }
}
